import { OutgoingMessage } from "./OutgoingMessage"

export const sendVuplexMessage = (message: OutgoingMessage) => {
  if (window.vuplex === undefined) return

  console.log("Sending Vuplex message", message)
  window.vuplex.postMessage(message)
}
